import { ActionContext, MutationTree, ActionTree, GetterTree } from 'vuex'
import { Role, ManagedUserModel } from '@/webApi/DataModels'
import webApi from '@/webApi'
import { filter, intersection, map } from 'lodash'
import moment from 'moment'
import constants from '../constants'

interface IUserListFilter {
  term: string;
  customers: number[];
  countries: number[];
}

class UserManagmentState {
  public userList: ManagedUserModel[] = []
  public activeUserList: ManagedUserModel[] = []
  public userListFiler:IUserListFilter = null
  public userRoles:Role[] =[]
  public filteredUserList: ManagedUserModel[] = []
}
const mutations = <MutationTree<UserManagmentState>>{
  setUserList (state: UserManagmentState, users: ManagedUserModel[]) {
    map(users, (user:ManagedUserModel) => {
      if (user.Lockout_End_Date_Utc) {
        var lockoutEndDate = moment.utc(user.Lockout_End_Date_Utc)
        var now = moment()
        user.Blocked = lockoutEndDate.isAfter(now)
      }
      if (user.Role_IDs) {
        user.Roles_String = user.Role_IDs.join(', ')
      } else {
        user.Roles_String = ''
      }
      if (user.All_Countries) {
        user.Countries = 'All'
      } else if (user.Country_Claims) {
        user.Countries = this.getters['country/countryNames'](user.Country_Claims).join(', ')
      } else {
        user.Countries = ''
      }
      if (user.All_Customers) {
        user.Customers = 'All'
      } else if (user.Customer_Claims) {
        user.Customers = this.getters['customer/customerNames'](user.Customer_Claims).join(', ')
      } else {
        user.Customers = ''
      }
    })
    state.userList = users
    state.filteredUserList = users
  },
  setActiveUserList (state: UserManagmentState, users: ManagedUserModel[]) {
    // eslint-disable-next-line
    map(users, (user:ManagedUserModel) => {
      if (user.Lockout_End_Date_Utc) {
        var lockoutEndDate = moment.utc(user.Lockout_End_Date_Utc)
        var now = moment()
        user.Blocked = lockoutEndDate.isAfter(now)
      }
      if (user.Role_IDs) {
        user.Roles_String = user.Role_IDs.join(', ')
      } else {
        user.Roles_String = ''
      }
      if (user.All_Countries) {
        user.Countries = 'All'
      } else if (user.Country_Claims) {
        user.Countries = this.getters['country/countryNames'](user.Country_Claims).join(', ')
      } else {
        user.Countries = ''
      }
      if (user.All_Customers) {
        user.Customers = 'All'
      } else if (user.Customer_Claims) {
        user.Customers = this.getters['customer/customerNames'](user.Customer_Claims).join(', ')
      } else {
        user.Customers = ''
      }
    })
    state.activeUserList = users
  },
  setRoleList (state: UserManagmentState, roles: Role[]) {
    state.userRoles = roles
  },
  // Sets the filter for the report list
  setFilter (state: UserManagmentState, userListFiler: IUserListFilter): void {
    state.userListFiler = userListFiler
    var term = userListFiler.term
    state.filteredUserList = filter(state.userList, (user) => {
      if (term.length === 0 && userListFiler.customers.length === 0 && userListFiler.countries.length === 0) {
        return true
      }
      var addUser = false
      if (term.length > 0) {
        if (user.Full_Name && user.Full_Name.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
          addUser = true
        } else if (user.User_Type && user.User_Type.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
          addUser = true
        } else if (user.Phone_Number && user.Phone_Number.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
          addUser = true
        } else if (user.Email && user.Email.toLowerCase().indexOf(term.toLowerCase()) !== -1) {
          addUser = true
        }
      }

      if (intersection(user.Customer_Claims, userListFiler.customers).length > 0) {
        addUser = true
      } else if (intersection(user.Country_Claims, userListFiler.countries).length > 0) {
        addUser = true
      }
      return addUser
    })
  },
  reset (state:UserManagmentState) {
    state.userList = []
    state.activeUserList = []
  }
}
const actions = <ActionTree<UserManagmentState, any>>{
  // loads a report
  loadUserList (store: ActionContext<UserManagmentState, any>): Promise<any> {
    return webApi.account
      .get_User_List()
      .then((response: any) => {
        var users: ManagedUserModel[] = response.data
        store.commit('setUserList', users)
        return Promise.resolve('success')
      })
      .catch(response => {
        window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        return Promise.reject(response)
      })
  },
  loadActiveUserList (store: ActionContext<UserManagmentState, any>): Promise<any> {
    return webApi.account
      .get_Active_User_List()
      .then((response: any) => {
        var users: ManagedUserModel[] = response.data
        store.commit('setActiveUserList', users)
        return Promise.resolve('success')
      })
      .catch(response => {
        window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
        return Promise.reject(response)
      })
  },
  loadRoleList (store: ActionContext<UserManagmentState, any>): Promise<any> {
    return store.dispatch('user/hasPermission', { permissionType: constants.PERMISSION_TYPES.USER, permissionValue: constants.PERMISSION_VALUES.LIST }, { root: true })
      .then((hasPermission): any => {
        if (!hasPermission) {
          return Promise.resolve('not needed')
        } else {
          return webApi.account.get_Roles()
            .then((response: any) => {
              var roles: Role[] = response.data
              store.commit('setRoleList', roles)
              return Promise.resolve('success')
            })
            .catch(response => {
              window.bus.$emit('openErrorModal', response.data.ExceptionMessage)
              return Promise.reject(response)
            })
        }
      })
  },
  reset (store: ActionContext<UserManagmentState, any>):void {
    store.commit('reset')
  }
}
const getters = <GetterTree<UserManagmentState, any>>{}
export default {
  namespaced: true,
  state: new UserManagmentState(),
  mutations,
  actions,
  getters
}
